import { MovieCheckOutlineIcon } from './MovieCheckOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 74A2D617-040C-4313-9D9B-CDB2FFDCC0D7
 * name movie-check-outline
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-check-outline.svg
 * tags
 * - Video / Movie 
 */
export const SlateCheckOutlineIcon = MovieCheckOutlineIcon;
export default SlateCheckOutlineIcon